type Operation = 'processDeletion' | 'makeDefault' | 'assignTariff';

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null;

/** Nest errors may have object details (G002/AZ100) or a plain conflict message. */
export const adminMutationError = (
  error: unknown,
  operation: Operation,
): string => {
  const transport = isRecord(error) ? error : {};
  const data = isRecord(transport.data) ? transport.data : {};
  const details = isRecord(data.details) ? data.details : {};
  const statusCode = data.statusCode ?? transport.status;
  const { errorCode } = details;

  if (statusCode === 403 || errorCode === 'AZ100') {
    return 'Your session does not have permission to perform this action.';
  }
  if (statusCode === 401) {
    return 'Your session has expired. Sign in again before retrying.';
  }
  if (operation === 'processDeletion' && statusCode === 409) {
    return 'This deletion request is already being processed or is no longer pending. Only pending requests can be processed.';
  }
  if (statusCode === 404 || errorCode === 'G002') {
    if (operation === 'processDeletion') {
      return 'This deletion request no longer exists or has been deleted.';
    }
    return 'This tariff plan is no longer available. It may be missing, deleted, inactive or private. Choose an available plan.';
  }
  if (
    transport.status === 'FETCH_ERROR' ||
    transport.status === 'TIMEOUT_ERROR'
  ) {
    return 'The server could not be reached. Check your connection and refresh the data before retrying.';
  }
  const action = {
    processDeletion: 'process the deletion request',
    makeDefault: 'change the default tariff plan',
    assignTariff: 'assign the tariff plan',
  }[operation];
  return `The server could not ${action}. Refresh the data before retrying${
    typeof errorCode === 'string' ? ` (error ${errorCode})` : ''
  }.`;
};
